import {reduxForm} from 'redux-form'
import DescriptiveSwitchField from 'components/Fields/ReduxForm/DescriptiveSwitchField'
import Header from 'pages/Employees/Header'
import styles from './PinForm.css'

class PinForm extends React.Component {
  render () {
    return <div className={styles.form}>
      <Header title='App Permission' />
      <div className={styles['ask-staff-info']}>
        Required PIN for the following access on mobile app
      </div>
      <div className={styles.description}>
        The PIN configuration
        will apply to outlet who have staff (except Administrators) with PIN assigned and have access to mobile apps.
      </div>
      <hr className={styles.separator} />
      {this.props.allowedFields.map((field) => <div>
        <DescriptiveSwitchField
          label={field.label}
          sublabel={field.description}
          name={field.name}
          disabled={false} // diganti jadi always enable karena ada pengeekan use-case yang gak dilaukan lagi (disable button if manager/staff doesn't have access to menu on app
          wrapperClassName={styles['switch-field']}
          disabledTooltipText={`Unable to turn on the PIN Access for this app permission because your Administrator role doesn't have access to app. Please configure the role and try again`}
        />
        <hr className={styles.separator} />
      </div>)}
      <div className='row'>
        <div className='col-lg-12'>
          <button className={`${styles['btn-save']} btn btn-primary pull-right`} onClick={this.props.handleSubmit}>Save</button>
        </div>
      </div>
    </div>
  }
}

PinForm.propTypes = {
  allowedFields: React.PropTypes.array
}
const mapForm = {
  form: 'pin'
}
export default reduxForm(mapForm)(PinForm)



// WEBPACK FOOTER //
// ./app/pages/Employees/Pin/PinForm/PinForm.js